import { http, httpRequest } from '@/utils/request'
import { CommonResponse, TableReponseType, TableRequestType } from '@/types'
import type { DeviceOperationPermissions } from './devicePermissions'

export interface DevicesType {
  permissions?: DeviceOperationPermissions
  id: string
  device_sn: string
  name: string
  product_id: string
  status: string
  platform: string
  cloud_instance_id: string
  cloud_product_id: string
  driver_service_name: string
  product_name: string
  last_sync_time: number
  last_online_time: number
  drive_instance_id: string
  system_version?: string
  board_version?: string
  iccid?: string
  created: number
  description: string
  install_location?: string
}

export function getDevice (params: TableRequestType & {
  product_id?: string
  group_id?: string
  name?: string
  status?: string
}) {
  return httpRequest<any, CommonResponse<TableReponseType<DevicesType>>>({
    url: '/api/v1/devices',
    params,
  })
}

export function addDevices (data: FormData, options: {
  owner_org_id?: string
  product_id: string
  driver_instance_id?: string
}) {
  const { product_id, driver_instance_id } = options
  const querys = []
  options.owner_org_id && querys.push(`owner_org_id=${encodeURIComponent(options.owner_org_id)}`)
  product_id && querys.push(`product_id=${product_id}`)
  driver_instance_id && querys.push(`driver_instance_id=${driver_instance_id}`)
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/devices/import?${querys.join('&')}`,
    method: 'post',
    data,
  })
}

export function deleteDevices (data: { device_ids: string[] }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices',
    method: 'delete',
    data,
  })
}

export function bindDriver (data: {
  device_ids: string[]
  driver_instance_id: string
}) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices/bind-driver',
    method: 'put',
    data,
  })
}

export function unBindDriver (data: { device_ids: string[] }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices/unbind-driver',
    method: 'put',
    data,
  })
}

export function downloadTemplate () {
  return http({
    url: '/api/v1/devices/import-template',
    responseType: 'blob',
  })
}

export function batchUpdateDevices (data: {
  device_ids: string[]
  description?: string
  name?: string
  drive_instance_id?: string
  install_location?: string
}) {
  return httpRequest<any, CommonResponse<{
    success_count: number
    fail_count: number
    failures?: Array<{ device_id: string; error: string }>
  }>>({
    url: '/api/v1/devices/batch-update',
    method: 'put',
    data,
  })
}

export function exportDevices (params: TableRequestType & {
  ids?: string
  product_id?: string
  group_id?: string
  name?: string
  platform?: string
  drive_instance_id?: string
  status?: string
}) {
  return http({
    url: '/api/v1/devices/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 发布产品
export function productRelease<T> (productId : string) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/product-release/${productId}`,
    method: 'post',
  })
}

// 取消产品发布
export function productUnrelease<T> (productId : string) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/product-unrelease/${productId}`,
    method: 'post',
  })
}
